export const AI_CHATBOT_BEGIN_RESPONSE = 'aiChatbot/beginAIResponse';
export const AI_CHATBOT_CANCEL_RESPONSE = 'aiChatbot/cancelAIResponse';
